export default __webpack_public_path__ + "static/media/Indira-kumar-dp.c9e3facf.jpeg";